import withAPIAction from 'helpers/withAPIAction'
import { BannerListReq, CreateBannerReq, UpdateBannerReq, DeleteBannerReq, BannerDetailReq } from './types'
import {
  getBannerListAction,
  createBannerAction,
  updateBannerAction,
  deleteBannerAction,
  getBannerDetailAction,
} from './actions'
import { APIPath } from 'services/APIPath'
import { appConfig } from 'config'
import { CreateMapping } from 'Store/common/common.types'

export const bannerListAPI = (data: BannerListReq, token: string) => {
  return withAPIAction<BannerListReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.bannerList,
    data,
    token,
    //withOath: true,
  })(getBannerListAction)
}

export const createBannerAPI = (data: CreateMapping<CreateBannerReq>, token: string) => {
  return withAPIAction<CreateMapping<CreateBannerReq>>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.createBanner,
    data,
    token,
  })(createBannerAction)
}

export const updateBannerAPI = (data: CreateMapping<UpdateBannerReq>, token: string) => {
  return withAPIAction<CreateMapping<UpdateBannerReq>>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.updateBanner,
    data,
    token,
  })(updateBannerAction)
}

export const deleteBannerAPI = (data: DeleteBannerReq, token: string) => {
  return withAPIAction<DeleteBannerReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.deleteBanner,
    data,
    token,
  })(deleteBannerAction)
}

export const getBannerDetailAPI = (data: BannerDetailReq, token: string) => {
  return withAPIAction<BannerDetailReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.getBannerByID,
    data,
    token,
  })(getBannerDetailAction)
}
